module.exports = __webpack_public_path__ + "img/meauicon2.cb23760f.svg";